import { clearLegacySharedDB, closeAllDBs, setCurrentUserId } from "./storage/schema";
import { getAgentBridge } from "./worker-bridge";

/**
 * Point all agent storage at `userId` (null = signed out).
 *
 * The storage scope is module state, and the agent Web Worker has its own
 * copy of that module — so the main thread and the worker are switched
 * separately. The old user's connections are closed first.
 */
export function setAgentUser(userId: string | null): void {
  void closeAllDBs();
  setCurrentUserId(userId);
  getAgentBridge().setUserId(userId);
  if (userId) void clearLegacySharedDB();
}
